import React from 'react';
import { useAuth } from '../Auth/AuthContext';
import DialerProvider from './DialerProvider';

const PHONE_ROLES = new Set(['agent', 'supervisor']);

/**
 * Global headless VoIP host. Lives inside BrowserRouter so dialers can useNavigate.
 * Embedded DialerProvider panels delegate call actions via CallModeContext.dialerActionsRef.
 */
const SoftphoneHost = () => {
  const { user, authChecked } = useAuth();

  if (!authChecked || !user || !PHONE_ROLES.has(user.role)) return null;

  return <DialerProvider isHost />;
};

export default SoftphoneHost;
